module.exports = __webpack_public_path__ + "media/images/athletes/1896-2aa03e7921c6f44d277b0427f6037338.png";